<template>
    <!-- 子菜单且有子子菜单 -->
    <el-sub-menu 
      v-if="item.children && item.children.length > 0 && !item.IsHide && !item.IsButton"
      :index="item.path || item.id"
    >
      <template #title>
        <el-icon v-if="item.meta?.icon || item.iconCls">
          <component :is="getIconComponent(item.meta?.icon || item.iconCls)" />
        </el-icon>
        <span class="menu-label">{{ item.meta?.title || item.name }}</span>
      </template>
      
      <!-- 递归渲染 -->
      <sidebar-menu-item 
        v-for="child in item.children" 
        :key="child.id" 
        :item="child"
        :is-collapse="isCollapse"
      />
    </el-sub-menu>
    
    <!-- 子菜单且是最终菜单项 -->
    <el-menu-item 
      v-else-if="!item.IsHide && !item.IsButton && item.path && item.path !== '-'"
      :index="item.path"
    >
      <a :href="getMenuHref(item.path)" @click="handleLinkClick" class="menu-anchor">
        <el-icon v-if="item.meta?.icon || item.iconCls">
          <component :is="getIconComponent(item.meta?.icon || item.iconCls)" />
        </el-icon>
        <span class="menu-label">{{ item.meta?.title || item.name }}</span>
      </a>
    </el-menu-item>
  </template>
  
  <script setup lang="ts">
  import { Menu, Document, Setting, User, House, Star } from '@element-plus/icons-vue'
  import * as AllIcons from '@element-plus/icons-vue'
  import { useRouter } from 'vue-router'

  const router = useRouter()
  
  defineProps({
    item: {
      type: Object,
      required: true
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  })

  const getMenuHref = (path: string) => {
    if (!path) return 'javascript:void(0);'
    try {
      return router.resolve(path).href
    } catch (e) {
      return 'javascript:void(0);'
    }
  }

  const handleLinkClick = (event: MouseEvent) => {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      event.stopPropagation()
      return
    }
    event.preventDefault()
  }
  
  // 图标映射函数
  const getIconComponent = (iconName: string) => {
    // 如果已经是组件，直接返回
    if (typeof iconName === 'object') {
      return iconName
    }
    
    // 图标名称映射
    const iconMap: Record<string, any> = {
      'fa-star': Star,
      'fa-home': House,
      'fa-user': User,
      'fa-cog': Setting,
      'fa-file': Document,
      'fa-menu': Menu,
      // 添加更多映射...
    }
    
    if (iconName in iconMap) {
      return iconMap[iconName]
    }

    const icons = AllIcons as Record<string, any>
    if (icons[iconName]) {
      return icons[iconName]
    }
    
    // 默认返回Menu图标
    return Menu
  }
  </script>

  <style scoped lang="less">
  .menu-anchor {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    color: inherit;
    text-decoration: none;
    outline: none;

    span {
      margin-left: 5px;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  </style>
